import type { FC } from 'react'
import styled from 'styled-components'

import OutcomeStatusPill from '@/components/OutcomeStatusPill'
import type { OutcomeStatus } from '@/types/Outcome'

interface Props {
  totalAmountVerified: number
  outcomeStatus: OutcomeStatus
  decisionComments: string[]
}

const Header = styled.h4``

const Section = styled.div`
  margin-top: 40px;
`

const TotalAmountVerified = styled.p<{ warning: boolean }>`
  font-size: 2em;
  margin: 0;

  color: ${props => (props.warning ? 'red' : 'inherit')};
`

const Warning = styled.p`
  color: red;
  font-size: 1.5em;
`

const TOTAL_VERIFIED_INCOME_CAP = 150000

const PreviewResult: FC<Props> = ({
  totalAmountVerified,
  outcomeStatus,
  decisionComments,
}) => {
  const displayTotalAmountVerifiedWarning =
    totalAmountVerified >= TOTAL_VERIFIED_INCOME_CAP

  return (
    <div>
      <div>
        <Header>Total amount verified</Header>
        <p>You are finalising this applicant's income during the tenancy term as: </p>
        <TotalAmountVerified warning={displayTotalAmountVerifiedWarning}>
          £{totalAmountVerified.toLocaleString()}
        </TotalAmountVerified>
        {displayTotalAmountVerifiedWarning && (
          <Warning>
            Amount over £150,000. Please review this application with a supervisor before
            confirming.
          </Warning>
        )}
      </div>
      <Section>
        <Header>Income outcome</Header>
        <OutcomeStatusPill outcomeStatus={outcomeStatus} />
      </Section>
      <Section>
        <Header>Decision comments</Header>
        <ul>
          {decisionComments.map((comment, i) => (
            <li key={i}>{comment}</li>
          ))}
        </ul>
      </Section>
      <Section>
        <p>Click the confirm button below to verify this applicant's income.</p>
      </Section>
    </div>
  )
}

export default PreviewResult
